import { useAuth } from "@/context/AuthContext";
import { Link, useLocation } from "react-router-dom";
import { Fingerprint, LogOut, ShieldCheck, LayoutGrid } from "lucide-react";
import { RecoveryBanner } from "@/components/RecoveryBanner";

export function AppShell({ children }) {
  const { user, logout } = useAuth();
  const loc = useLocation();
  return (
    <div className="min-h-screen bg-monk-bg text-white">
      <header className="sticky top-0 z-40 bg-black/90 backdrop-blur-xl border-b border-white/10">
        <div className="max-w-[1600px] mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group" data-testid="brand-home">
            <div className="w-9 h-9 rounded-md bg-monk-blue/15 border border-monk-blue/40 flex items-center justify-center">
              <Fingerprint className="w-5 h-5 text-monk-blue" />
            </div>
            <div className="leading-none">
              <div className="font-heading font-800 text-lg tracking-tighter">MONK</div>
              <div className="overline mt-0.5">Forensic Intelligence</div>
            </div>
          </Link>
          <nav className="flex items-center gap-1">
            <Link to="/" data-testid="nav-command-center"
              className={`px-3 py-2 rounded-md text-sm flex items-center gap-2 transition-colors ${loc.pathname === "/" ? "bg-white/10 text-white" : "text-neutral-400 hover:text-white hover:bg-white/5"}`}>
              <LayoutGrid className="w-4 h-4" /> Command Center
            </Link>
          </nav>
          <div className="flex items-center gap-4">
            <div className="text-right leading-tight hidden sm:block">
              <div className="text-sm font-medium" data-testid="user-name">{user?.name}</div>
              <div className="flex items-center gap-1 justify-end">
                <ShieldCheck className="w-3 h-3 text-monk-blue" />
                <span className="overline" data-testid="user-role">{user?.role} · {user?.badge}</span>
              </div>
            </div>
            <button onClick={logout} data-testid="logout-btn"
              className="w-9 h-9 rounded-md border border-white/10 flex items-center justify-center text-neutral-400 hover:text-monk-critical hover:border-monk-critical/40 transition-colors">
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-[1600px] mx-auto px-6 py-8"><RecoveryBanner />{children}</main>
    </div>
  );
}
